import { Box, Typography } from "@mui/material"
import type { FC } from "react"

import CommentsSection from "@/components/Comment/CommentsSection"
import { CommentParentTableType } from "@/graphql/codegen/graphql"

interface InvoiceCommentsProps {
  invoiceId: string
}

export const InvoiceComments: FC<InvoiceCommentsProps> = ({ invoiceId }) => {
  return (
    <Box className='flex flex-1 flex-col gap-3 p-4' data-testid='invoices.comments-pane.container'>
      <Typography variant='h6' className='text-gray-900'>
        Comments
      </Typography>
      <CommentsSection referenceId={invoiceId} type={CommentParentTableType.Invoice} />
    </Box>
  )
}
